
import { Menu, X } from 'lucide-react';
import { LanguageToggle } from '../LanguageToggle';

interface MobileMenuButtonProps {
  isOpen: boolean;
  onToggle: () => void;
}

export function MobileMenuButton({ isOpen, onToggle }: MobileMenuButtonProps) {
  return (
    <div className="flex items-center lg:hidden gap-2">
      <LanguageToggle />
      <button
        onClick={onToggle}
        className="inline-flex items-center justify-center p-2 rounded-md text-foreground hover:bg-secondary/50 transition-colors"
        aria-expanded={isOpen}
      >
        <span className="sr-only">Open main menu</span>
        {isOpen ? (
          <X className="block h-5 w-5" aria-hidden="true" />
        ) : (
          <Menu className="block h-5 w-5" aria-hidden="true" />
        )}
      </button>
    </div>
  );
}
